import { Injectable } from '@angular/core';
import { LoadingOptions, loadingController } from '@bkkr/core';

import { OverlayBaseController } from '../util/overlay';

@Injectable({
  providedIn: 'root',
})
export class LoadingController extends OverlayBaseController<LoadingOptions, HTMLBkkrLoadingElement> {
  constructor() {
    super(loadingController);
  }
}
